// Language tabs for the Week of Prayer day cards.
// Self-contained so the block does not depend on the Bootstrap tab plugin.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("section.week-of-prayer").forEach(function (section) {
    var tabs = Array.prototype.slice.call(
      section.querySelectorAll(".week-of-prayer__tab")
    );
    if (!tabs.length) return;

    function activate(index, setFocus) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        var panel = document.getElementById(tab.getAttribute("aria-controls"));

        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");

        if (panel) {
          panel.classList.toggle("is-active", isActive);
          if (isActive) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        }
      });

      if (setFocus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () {
        activate(i, false);
      });

      // Left/right arrows move between tabs, per the WAI-ARIA tabs pattern.
      tab.addEventListener("keydown", function (e) {
        var next = null;
        if (e.key === "ArrowRight") next = (i + 1) % tabs.length;
        if (e.key === "ArrowLeft") next = (i - 1 + tabs.length) % tabs.length;
        if (e.key === "Home") next = 0;
        if (e.key === "End") next = tabs.length - 1;

        if (next !== null) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });
  });
});
